// @flow
import { createSelector } from 'reselect';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import { SOURCES_MODULE_NAME, LIST_STATE_NAME } from '../constants';

export function isSourcesFetching(state: Object) {
  return get(state, [SOURCES_MODULE_NAME, LIST_STATE_NAME, 'isFetching']);
}

export function getSourcesError(state: Object) {
  return get(state, [SOURCES_MODULE_NAME, LIST_STATE_NAME, 'error']);
}

export function getSourcesData(state: Object) {
  return get(state, [SOURCES_MODULE_NAME, LIST_STATE_NAME, 'data']);
}

export const hasSources = createSelector<Object, *, *, *>(
  [getSourcesData],
  (sources: Array<Object>): boolean => isArray(sources) && sources.length > 0
);



// WEBPACK FOOTER //
// ./app/Sources/list/selectors.js